import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, formDataCommonFunctionPut, serviceCall } from '../../serviceCall'

const raiseRefundApi = (data, callback, errorCallBack, params) => {

    return async (dispatch) => {

        formDataCommonFunctionPut(data, apiConstants.PAYMENT_GATEWAY.RAISE_REFUND)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
}

export default raiseRefundApi;